"use client";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

interface IBuyThisForMyselfComponent {
  handleCheckbox: any;
  giftCardSellingEnabled: boolean;
  showRecipientInformation: boolean;
  merchantColor: string;
}

export const BuyThisForMyselfComponent = ({
  handleCheckbox,
  giftCardSellingEnabled,
  showRecipientInformation,
  merchantColor,
}: IBuyThisForMyselfComponent) => {
  const t = useTranslations("BuyThisForMyselfComponent");
  return (
    <div
      data-testid={applyDataTestId(pom.giftCard.buyThisForMyselfCheckbox)}
      className="flex gap-2 cursor-pointer"
    >
      <input
        id="buy-this-for-myself"
        style={{ accentColor: merchantColor }}
        className={`cursor-pointer`}
        type="checkbox"
        onChange={handleCheckbox}
        disabled={!giftCardSellingEnabled}
        checked={!showRecipientInformation}
      />
      <label
        htmlFor="buy-this-for-myself"
        className={`text-[15px] leading-[24px] font-normal cursor-pointer ${
          !giftCardSellingEnabled ? "opacity-50" : ""
        }`}
      >
        {t("checkboxLabel")}
      </label>
    </div>
  );
};
